import { createFileRoute } from '@tanstack/react-router';
import { CleanerRegistrationCompleted } from '@/features/cleaner/registrations/cleaner-completed';

export const Route = createFileRoute(
  '/(cleaner)/_registration/cleaner/signup-completed'
)({
  component: CleanerRegistrationCompleted,
});
